import { PreviewParameters } from "./PreviewParameters";
import { Item } from "./Item";
import { MoveableOverlay } from "./moveable-overlays/MoveableOverlay";
import { MoveableOverlayImage } from "./moveable-overlays/MoveableOverlayImage";
import { MoveableOverlayVideo } from "./moveable-overlays/MoveableOverlayVideo";
import { MoveableOverlayStockImage } from "./moveable-overlays/MoveableOverlayStockImage";
import { MoveableOverlayText } from "./moveable-overlays/MoveableOverlayText";
import { MoveableOverlayShape } from "./moveable-overlays/MoveableOverlayShape";
import { MoveableOverlayAnimation } from "./moveable-overlays/MoveableOverlayAnimation";
import { MoveableOverlayEmojipediaImage } from "./moveable-overlays/MoveableOverlayEmojipediaImage";
import { IItemVariationParametersCopy } from "../interfaces/IItemVariationParametersCopy";
import { MoveableOverlayStockVideo } from "./moveable-overlays/MoveableOverlayStockVideo";
import { EndCard } from "./end-card/EndCard";
import { IMusic } from "../interfaces/IMusic";

export class ItemVariation {
  checked: boolean;

  isSaveOriginalName: boolean;
  outputNameTemplate: any;
  preset: any;

  filter: any;
  flipVertical: boolean;
  flipHorizontal: boolean;

  currentSize: any;

  cut: any;
  speed: number;
  music: IMusic;
  volume: number;

  backgroundColor: string;
  backgroundImage: any;

  overlays: MoveableOverlay[];
  overlaysOfBackside: MoveableOverlay[];

  isLoadingPackshot: Boolean;
  endCard: any;

  previewParameters: PreviewParameters;

  parentItem: any;
  //TODO id
  id: string;

  fileOutputParameters: any;
  isRemoveMetadata: boolean;

  isSharpEnabled: boolean;

  isShowNoticeSharpen: boolean;

  shadow: object;

  constructor() {
    this.id = `f${(~~(Math.random() * 1e8)).toString(16)}`;

    this.isSaveOriginalName = false;
    this.outputNameTemplate = null;
    this.currentSize = null;

    this.cut = null;
    this.speed = 1;
    this.music = {
      file: null,
      libraryType: null,
      startTime: 0,
      isCustomTime: false,
      volume: 1,
      isExtendToEndCard: false,
    };
    this.volume = 1;

    this.endCard = new EndCard();
    this.isLoadingPackshot = false;

    this.previewParameters = new PreviewParameters();

    this.overlays = [];
    this.overlaysOfBackside = [];
    this.preset = { name: "crop", title: "Crop" };

    this.checked = false;
    this.backgroundColor = "#ffffff";
    this.backgroundImage = { id: null, src: "", w: 0, h: 0 };
    /* this.filter = {
      title: "Original",
      name: "",
      serverName: null,
      styleFilers: "none",
      value: 0
    }; */
    this.filter = {
      currentPreset: "Original",
      presetIntensety: 100,
      adjustment: {
        brightness: 1,
        contrast: 1,
        saturation: 1,
        tint: 0,
        invert: 0,
        sepia: 0,
        glitch: null,
        sharpen: 0,
      },
    };
    this.flipVertical = false;
    this.flipHorizontal = false;
    this.parentItem = null;
    this.fileOutputParameters = {
      bitrate: 0,
      normalBitrate: 0,
      isStrictMaxSize: false,
    };
    this.isRemoveMetadata = true;
    this.isSharpEnabled = false;
    this.isShowNoticeSharpen = false;

    this.shadow = {
      visible: false,
      color: '#000',
      opacity: 1,
      offset: {
        x: 0,
        y: 0,
      },
      blur: 40,
    }
  }

  copy(): ItemVariation {
    let copy = new ItemVariation();

    copy.isSaveOriginalName = this.isSaveOriginalName;
    copy.outputNameTemplate = JSON.parse(JSON.stringify(this.outputNameTemplate));
    copy.currentSize = JSON.parse(JSON.stringify(this.currentSize));

    copy.cut = JSON.parse(JSON.stringify(this.cut));
    copy.speed = this.speed;
    copy.music = JSON.parse(JSON.stringify(this.music));
    copy.volume = this.volume;

    copy.isLoadingPackshot = false;
    copy.endCard = EndCard.copyFromParsed(this.endCard);

    copy.previewParameters = this.previewParameters.copy();

    this.overlays?.forEach((o) => {
      let overlayCopy = o.copy();
      overlayCopy.variationId = copy.id;
      overlayCopy.isCustomTime = true;
      copy.overlays.push(overlayCopy);
    });

    this.overlaysOfBackside?.forEach((o) => {
      let overlayCopy = o.copy();
      overlayCopy.variationId = copy.id;
      overlayCopy.isCustomTime = true;
      copy.overlaysOfBackside.push(overlayCopy);
    });

    copy.preset = JSON.parse(JSON.stringify(this.preset));

    copy.checked = JSON.parse(JSON.stringify(this.checked));
    copy.backgroundColor = JSON.parse(JSON.stringify(this.backgroundColor));
    copy.backgroundImage = JSON.parse(JSON.stringify(this.backgroundImage));
    copy.filter = JSON.parse(JSON.stringify(this.filter));
    copy.flipVertical = this.flipVertical;
    copy.flipHorizontal = this.flipHorizontal;

    copy.parentItem = JSON.parse(JSON.stringify(this.parentItem));
    copy.fileOutputParameters = JSON.parse(
      JSON.stringify(this.fileOutputParameters)
    );
    copy.isRemoveMetadata = this.isRemoveMetadata;
    copy.isSharpEnabled = this.isSharpEnabled;
    copy.isShowNoticeSharpen = this.isShowNoticeSharpen;

    Object.assign(copy.shadow, this.shadow)

    return copy;
  }

  static copyFromParsed(parsedObject): ItemVariation {
    let copy = new ItemVariation();

    copy.isSaveOriginalName = parsedObject.isSaveOriginalName;
    if (parsedObject.outputNameTemplate !== undefined) {
      copy.outputNameTemplate = parsedObject.outputNameTemplate;
    }
    if (copy.isSaveOriginalName === undefined) {
      copy.isSaveOriginalName = false;
    }
    copy.currentSize = JSON.parse(JSON.stringify(parsedObject.currentSize));

    copy.cut = JSON.parse(JSON.stringify(parsedObject.cut));
    copy.speed = parsedObject.speed;

    const parsedMusic = parsedObject.music;
    copy.music = {
      file: !!parsedMusic.file
        ? parsedMusic.file
        : !!parsedMusic.stockFile
        ? parsedMusic.stockFile
        : null,
      libraryType: !!parsedMusic.libraryType
        ? parsedMusic.libraryType
        : !!parsedMusic.stockFile
        ? "stock-roasup"
        : "uploaded",
      startTime: parsedMusic.startTime,
      isCustomTime: !!parsedMusic.isCustomTime,
      volume: parsedMusic.volume,
      isExtendToEndCard: !!parsedMusic.isExtendToEndCard,
    };

    copy.volume =
      parsedObject.volume || parsedObject?.volume === 0
        ? parsedObject.volume
        : 1;

    if (parsedObject.endCard) {
      copy.endCard = EndCard.copyFromParsed(parsedObject.endCard);

      // MIGRATION (ADD LOTTIE PACKSHOT)
      if (copy?.endCard?.packshot && !copy?.endCard?.packshot?.type) {
        copy.endCard.packshot.type = "video";
      }
      // MIGRATION (ADD LOTTIE PACKSHOT)
      if (!copy.hasOwnProperty("isLoadingPackshot")) {
        copy.isLoadingPackshot = false;
      }
      // MIGRATION (ADD LOTTIE PACKSHOT)
      if (!copy.hasOwnProperty("isShowNoticeSharpen")) {
        copy.isShowNoticeSharpen = false;
      }
    }

    copy.previewParameters = PreviewParameters.copyFromParsed(
      parsedObject.previewParameters
    );

    function recreateOverlay(o: any): MoveableOverlay {
      let overlayCopy;
      let overlayType = !!o.type
        ? o.type
        : o.value !== undefined
        ? "text"
        : o.style !== undefined
        ? "shape"
        : !!o.stockFile
        ? "stock"
        : o.file.type === "image"
        ? "image"
        : "video";
      switch (overlayType) {
        case "image":
          overlayCopy = MoveableOverlayImage.copyFromParsed(o);
          break;
        case "video":
          overlayCopy = MoveableOverlayVideo.copyFromParsed(o);
          break;
        case "stock":
          overlayCopy = MoveableOverlayStockImage.copyFromParsed(o);
          if (!o.file && !!o.stockFile) {
            overlayCopy.file = JSON.parse(JSON.stringify(o.stockFile));
          }
          break;
        case "stock-video":
          overlayCopy = MoveableOverlayStockVideo.copyFromParsed(o);
          break;
        case "emojipedia":
          overlayCopy = MoveableOverlayEmojipediaImage.copyFromParsed(o);
          break;
        case "text":
          overlayCopy = MoveableOverlayText.copyFromParsed(o);
          break;
        case "shape":
          overlayCopy = MoveableOverlayShape.copyFromParsed(o);
          break;
        case "animation":
          overlayCopy = MoveableOverlayAnimation.copyFromParsed(o);
          break;
        default:
          break;
      }
      overlayCopy.variationId = copy.id;
      overlayCopy.isCustomTime = true;
      return overlayCopy;
    }

    parsedObject.overlays?.forEach((o) => {
      copy.overlays.push(recreateOverlay(o));
    });

    parsedObject.overlaysOfBackside?.forEach((o) => {
      copy.overlaysOfBackside.push(recreateOverlay(o));
    });

    copy.preset =
      parsedObject.preset.name === "white" ||
      parsedObject.preset.name === "black"
        ? { name: "color", simpleTitle: "Color", title: "Color" }
        : JSON.parse(JSON.stringify(parsedObject.preset));
    if (copy.currentSize.title === "Original") {
      copy.preset = Item.presets.find((preset) => preset.name === "color");
    }

    copy.checked = JSON.parse(JSON.stringify(parsedObject.checked));
    copy.backgroundColor =
      parsedObject.preset.name === "white"
        ? "#ffffff"
        : parsedObject.preset.name === "black"
        ? "#000000"
        : JSON.parse(JSON.stringify(parsedObject.backgroundColor));
    copy.backgroundImage = JSON.parse(
      JSON.stringify(parsedObject.backgroundImage)
    );
    copy.filter =
      parsedObject.filter.currentPreset === undefined
        ? copy.migrateOldFilterToNew(parsedObject.filter)
        : JSON.parse(JSON.stringify(parsedObject.filter));
    if (!copy.filter.adjustment.hasOwnProperty("sepia")) {
      copy.filter.adjustment.sepia = 0;
    }
    if (!copy.filter.adjustment.hasOwnProperty("glitch")) {
      copy.filter.adjustment.glitch = null;
    }
    if (!copy.filter.adjustment.hasOwnProperty("sharpen")) {
      copy.filter.adjustment.sharpen = 0;
    }
    copy.flipVertical =
      parsedObject.flipVertical !== undefined
        ? parsedObject.flipVertical
        : false;
    copy.flipHorizontal =
      parsedObject.flipHorizontal !== undefined
        ? parsedObject.flipHorizontal
        : false;

    if (parsedObject.fileOutputParameters) {
      copy.fileOutputParameters = JSON.parse(
        JSON.stringify(parsedObject.fileOutputParameters)
      );
      if (
        !parsedObject.fileOutputParameters.hasOwnProperty("isStrictMaxSize")
      ) {
        copy.fileOutputParameters.isStrictMaxSize = false;
      }
    }
    copy.isRemoveMetadata =
      parsedObject.isRemoveMetadata !== undefined
        ? parsedObject.isRemoveMetadata
        : true;
    copy.isSharpEnabled = parsedObject.hasOwnProperty("isSharpEnabled")
      ? parsedObject.isSharpEnabled
      : false;

     copy.isShowNoticeSharpen = parsedObject.isShowNoticeSharpen;
    //copy.parentItem = parsedObject.parentItem;
    Object.assign(copy.shadow, parsedObject.shadow)

    return copy;
  }

  copyParameters(): IItemVariationParametersCopy {
    let copy: IItemVariationParametersCopy = {
      isSaveOriginalName: this.isSaveOriginalName,
      outputNameTemplate: this.outputNameTemplate,
      preset: this.preset,

      filter: this.filter,
      flipVertical: this.flipVertical,
      flipHorizontal: this.flipHorizontal,

      currentSize: this.currentSize,

      speed: this.speed,
      music: this.music,
      volume: this.volume,

      backgroundColor: this.backgroundColor,
      backgroundImage: this.backgroundImage,

      overlays: this.overlays,
      overlaysOfBackside: this.overlaysOfBackside,

      isLoadingPackshot: false,
      endCard: this.endCard,

      previewParameters: this.previewParameters,

      isRemoveMetadata: this.isRemoveMetadata,

      isSharpEnabled: this.isSharpEnabled,

      isShowNoticeSharpen: this.isShowNoticeSharpen,

      shadow: this.shadow,
    };
    return copy;
  }

  pasteParameters(
    copy: IItemVariationParametersCopy,
    variationParentItem: Item
  ): void {
    this.isSaveOriginalName = copy.isSaveOriginalName;

    //TODO проверить нестандартные размеры
    this.currentSize = variationParentItem
      .getVideoSizes(
        variationParentItem.isForSlice
          ? null
          : variationParentItem.inputSize.name,
        !variationParentItem.isForSlice
      )
      .find((size) => size.name === copy.currentSize.name);
    if (!this.parentItem.isForSlice && copy.preset.name !== "slicer") {
      this.preset = JSON.parse(JSON.stringify(copy.preset));
    }
    this.recalcOuterVideoResolutions();
    this.calcVideoPreviewPositon(this.preset.name);

    const targetOutX =
      copy.previewParameters.outerVideoResolutionX *
      copy.previewParameters.userOuterVideoResolutionsDifference;
    if (
      targetOutX !==
      this.previewParameters.outerVideoResolutionX *
        this.previewParameters.userOuterVideoResolutionsDifference
    ) {
      this.previewParameters.userOuterVideoResolutionsDifference =
        targetOutX / this.previewParameters.outerVideoResolutionX;
      this.previewParameters.checkAndUpdateUserOuterVideoResolutions();
      this.recalcFileOutputParameters();
    }

    if (this.previewParameters.userOuterVideoResolutionsDifference <= 1) {
      this.isSharpEnabled = false;
    }

    this.previewParameters.zoom =
      copy.previewParameters.zoom > this.previewParameters.maxZoom
        ? this.previewParameters.maxZoom
        : copy.previewParameters.zoom < this.previewParameters.minZoom
        ? this.previewParameters.minZoom
        : copy.previewParameters.zoom;

    if (this.previewParameters.maxHorizontalShift !== 0) {
      this.previewParameters.displayHorizontalShift =
        copy.previewParameters.displayHorizontalShift;
      this.previewParameters.horizontalShift = this.getShiftByDisplayShift(
        true
      );
    }
    if (this.previewParameters.maxVerticalShift !== 0) {
      this.previewParameters.displayVerticalShift =
        copy.previewParameters.displayVerticalShift;
      this.previewParameters.verticalShift = this.getShiftByDisplayShift(false);
    }
    this.shiftVideoPreview(
      this.previewParameters.horizontalShift,
      this.previewParameters.verticalShift
    );

    this.outputNameTemplate = JSON.parse(
      JSON.stringify(copy.outputNameTemplate)
    );
    this.speed = copy.speed;

    this.music = JSON.parse(JSON.stringify(copy.music));

    this.volume = copy.volume;

    this.isLoadingPackshot = false;
    this.endCard = !this.parentItem.isOutsize
      ? EndCard.copyFromParsed(copy.endCard)
      : this.endCard;

    function recreateOverlay(
      o: any,
      variation: ItemVariation
    ): MoveableOverlay {
      let overlayCopy;
      switch (o.type) {
        case "image":
          overlayCopy = MoveableOverlayImage.copyFromParsed(o);
          break;
        case "video":
          overlayCopy = MoveableOverlayVideo.copyFromParsed(o);
          break;
        case "stock":
          overlayCopy = MoveableOverlayStockImage.copyFromParsed(o);
          break;
        case "stock-video":
          overlayCopy = MoveableOverlayStockVideo.copyFromParsed(o);
          break;
        case "emojipedia":
          overlayCopy = MoveableOverlayEmojipediaImage.copyFromParsed(o);
          break;
        case "text":
          overlayCopy = MoveableOverlayText.copyFromParsed(o);
          break;
        case "shape":
          overlayCopy = MoveableOverlayShape.copyFromParsed(o);
          break;
        case "animation":
          overlayCopy = MoveableOverlayAnimation.copyFromParsed(o);
          break;
        default:
          break;
      }
      overlayCopy.variationId = variation.id;
      overlayCopy.isCustomTime = true;
      overlayCopy.startTime = 0;
      overlayCopy.finishTime = variation.parentItem.duration;
      return overlayCopy;
    }

    this.overlays = [];
    copy.overlays?.forEach((o) => {
      this.overlays.push(recreateOverlay(o, this));
    });

    this.overlaysOfBackside = [];
    copy.overlaysOfBackside?.forEach((o) => {
      this.overlaysOfBackside.push(recreateOverlay(o, this));
    });

    this.backgroundColor = JSON.parse(JSON.stringify(copy.backgroundColor));
    this.backgroundImage = JSON.parse(JSON.stringify(copy.backgroundImage));
    this.filter = JSON.parse(JSON.stringify(copy.filter));
    this.flipVertical = copy.flipVertical;
    this.flipHorizontal = copy.flipHorizontal;

    this.isRemoveMetadata = copy.isRemoveMetadata;
    this.isSharpEnabled = copy.isSharpEnabled;

    this.shadow = copy.shadow
  }

  getAllOverlays() {
    return this.overlays.concat(this.overlaysOfBackside);
  }

  recalcOuterVideoResolutions() {
    if (this.parentItem.isForSlice) {
      this.recalcOuterVideoResolutionsSlicer();
    } else {
      this.recalcOuterVideoResolutionsResizer();
    }
  }

  clearPrewiew() {
    this.previewParameters.top = null;
    this.previewParameters.left = null;
    this.previewParameters.width = 100;
    this.previewParameters.height = 100;
  }

  recalcZoomParams() {
    if (this.parentItem.isForSlice) {
      switch (this.currentSize.name) {
        case "S":
          this.previewParameters.minZoom = 60;
          break;
        case "P":
          this.previewParameters.minZoom = 90;
          break;
        case "F":
          this.previewParameters.minZoom = 80;
          break;
        default:
          this.previewParameters.minZoom = 100;
          break;
      }
    } else {
      if (this.preset.name === "crop" || this.preset.name === "tile") {
        this.previewParameters.minZoom = 100;
      } else {
        this.previewParameters.minZoom = 10;
      }
    }
  }

  clearShiftsAndZoom() {
    this.previewParameters.displayHorizontalShift = 0;
    this.previewParameters.displayVerticalShift = 0;
    this.recalcZoomParams();
    this.previewParameters.zoom = 100;
    this.previewParameters.verticalShift = this.getShiftByDisplayShift(false);
    this.previewParameters.horizontalShift = this.getShiftByDisplayShift(true);
  }

  getMaxShifts() {
    return this.parentItem.isForSlice
      ? this.getMaxShiftsSlicer()
      : this.getMaxShiftsResizer();
  }

  calcVideoPreviewPositon(mode) {
    let previewParameters = this.previewParameters;
    let maxDisplayShift = PreviewParameters.CONSTANT_MAX_DISPLAY_SHIFT_VALUE;
    if (mode === "tile" || mode === "default") {
      this.clearPrewiew();
      this.clearShiftsAndZoom();
    }
    if (
      mode === "blur" ||
      mode === "color" ||
      mode === "image" ||
      mode === "tile"
    ) {
      this.clearPrewiew();

      let outX = previewParameters.outerVideoResolutionX;
      let outY = previewParameters.outerVideoResolutionY;

      let customShiftPadding = this.getCustomShiftPadding();
      previewParameters.customVerticalPadding =
        customShiftPadding.verticalPadding;
      previewParameters.customHorizontalPadding =
        customShiftPadding.horizontalPadding;
      let zoom = this.previewParameters.zoom / 100;
      previewParameters.maxVerticalShift =
        outY + (outY - 2 * customShiftPadding.verticalPadding) * zoom;
      previewParameters.maxHorizontalShift =
        outX + (outX - 2 * customShiftPadding.horizontalPadding) * zoom;

      let inX = this.parentItem.innerVideoResolutionX;
      let inY = this.parentItem.innerVideoResolutionY;

      const isHeightIncrease =
        inX / inY <
        this.currentSize.defaultWidth / this.currentSize.defaultHeight;

      previewParameters.width = isHeightIncrease
        ? (this.currentSize.defaultHeight /
            this.currentSize.defaultWidth /
            inY) *
          inX *
          previewParameters.zoom
        : previewParameters.zoom;
      previewParameters.height = isHeightIncrease
        ? previewParameters.zoom
        : (this.currentSize.defaultWidth /
            this.currentSize.defaultHeight /
            inX) *
          inY *
          previewParameters.zoom;

      previewParameters.verticalShift = this.getShiftByDisplayShift(false);
      previewParameters.horizontalShift = this.getShiftByDisplayShift(true);

      previewParameters.displayMinHorizontalShift =
        previewParameters.maxHorizontalShift === 0 ? 0 : -maxDisplayShift;
      previewParameters.displayMaxHorizontalShift =
        previewParameters.maxHorizontalShift === 0 ? 0 : maxDisplayShift;
      previewParameters.displayMinVerticalShift =
        previewParameters.maxVerticalShift === 0 ? 0 : -maxDisplayShift;
      previewParameters.displayMaxVerticalShift =
        previewParameters.maxVerticalShift === 0 ? 0 : maxDisplayShift;
    } else if (mode === "crop" || mode === "slicer") {
      previewParameters.top = null;
      previewParameters.left = null;

      var maxShifts = this.getMaxShifts();
      previewParameters.maxVerticalShift = maxShifts.maxVerticalShift;
      previewParameters.maxHorizontalShift = maxShifts.maxHorizontalShift;

      previewParameters.width = maxShifts.width;
      previewParameters.height = maxShifts.height;

      previewParameters.verticalShift = this.getShiftByDisplayShift(false);
      previewParameters.horizontalShift = this.getShiftByDisplayShift(true);

      previewParameters.displayMinHorizontalShift =
        previewParameters.maxHorizontalShift === 0 ? 0 : -maxDisplayShift;
      previewParameters.displayMaxHorizontalShift =
        previewParameters.maxHorizontalShift === 0 ? 0 : maxDisplayShift;
      previewParameters.displayMinVerticalShift =
        previewParameters.maxVerticalShift === 0 ? 0 : -maxDisplayShift;
      previewParameters.displayMaxVerticalShift =
        previewParameters.maxVerticalShift === 0 ? 0 : maxDisplayShift;

      //this.recalcCropsParams(screenDiv);
    }
  }

  recalcCropsParams(screenDivWidth) {
    let previewParameters = this.previewParameters;
    let outX = previewParameters.outerVideoResolutionX;
    let outY = previewParameters.outerVideoResolutionY;

    let screenDivHeightForCurrentSize = (screenDivWidth * outY) / outX;

    if (previewParameters.maxVerticalShift !== 0) {
      let windowH = screenDivHeightForCurrentSize;
      previewParameters.stepVerticalShift = windowH / outY;
    }
    if (previewParameters.maxHorizontalShift !== 0) {
      let windowW = screenDivWidth;
      previewParameters.stepHorizontalShift = windowW / outX;
    }
    this.shiftVideoPreview(
      previewParameters.horizontalShift,
      previewParameters.verticalShift
    );
  }

  shiftVideoPreview(x, y) {
    let previewParameters = this.previewParameters;
    if (previewParameters.maxVerticalShift !== 0 && y !== null) {
      previewParameters.verticalShift = y;
      const shift = y * previewParameters.stepVerticalShift;
      previewParameters.top = -shift;
    }
    if (previewParameters.maxHorizontalShift !== 0 && x !== null) {
      previewParameters.horizontalShift = x;
      const shift = x * previewParameters.stepHorizontalShift;
      previewParameters.left = -shift;
    }
  }

  getCustomPaddingsInPixels() {
    if (this.preset.name === "crop" || this.preset.name === "slicer") {
      return {
        verticalPadding: 0,
        horizontalPadding: 0,
      };
    }
    return {
      verticalPadding:
        (this.previewParameters.customVerticalPadding *
          this.previewParameters.stepVerticalShift *
          this.previewParameters.zoom) /
        100,
      horizontalPadding:
        (this.previewParameters.customHorizontalPadding *
          this.previewParameters.stepHorizontalShift *
          this.previewParameters.zoom) /
        100,
    };
  }

  /* 	getOLDShiftByDisplayShift(displayValue, maxShift) {
      let maxDisplayShift = PreviewParameters.CONSTANT_MAX_DISPLAY_SHIFT_VALUE;
      let inX = this.parentItem.innerVideoResolutionX;
      let inY = this.parentItem.innerVideoResolutionY;
      let outX = this.previewParameters.outerVideoResolutionX;
      let outY = this.previewParameters.outerVideoResolutionY;
      let dif = maxShift === this.previewParameters.maxVerticalShift ? (inY - outY) / 2 : (inX - outX) / 2;
      return this.preset.name === 'crop' || this.preset.name === 'slicer'
        ? ((displayValue + maxDisplayShift) / (maxDisplayShift * 2)) * maxShift
        : ((displayValue) / (maxDisplayShift * 2)) * maxShift + dif;
    } */

  getShiftByDisplayShift(isHorizontal: boolean) {
    let displayValue = isHorizontal
      ? this.previewParameters.displayHorizontalShift
      : this.previewParameters.displayVerticalShift;
    let maxShift = isHorizontal
      ? this.previewParameters.maxHorizontalShift
      : this.previewParameters.maxVerticalShift;
    let maxDisplayShift = PreviewParameters.CONSTANT_MAX_DISPLAY_SHIFT_VALUE;
    let size = isHorizontal
      ? this.previewParameters.outerVideoResolutionX
      : this.previewParameters.outerVideoResolutionY;
    let dif = (size * (this.previewParameters.zoom / 100 - 1)) / 2;
    return this.preset.name === "crop" || this.preset.name === "slicer"
      ? ((displayValue + maxDisplayShift) / (maxDisplayShift * 2)) * maxShift
      : (displayValue / (maxDisplayShift * 2)) * maxShift + dif;
  }

  //RESIZER

  static getInitialResizerSize(inputSizeName: string) {
    let originalSize = null;
    if (inputSizeName.length === 1) {
      originalSize = JSON.parse(
        JSON.stringify(Item.videoSizes.find((s) => s.name === inputSizeName))
      );
      originalSize.simpleTitle = originalSize.simpleTitle + "*";
      originalSize.title = "Original";
    }
    switch (inputSizeName) {
      /* 			case "H":
            case "F":
              return Item.getVideoSize('S');
            case "S":
            case "P":
            case "V":
              return Item.getVideoSize('F'); */
      case "H":
      case "F":
      case "S":
      case "P":
      case "V":
        return originalSize;
      case "LS":
      case "RS":
        return Item.getVideoSize("S");
      case "LF":
      case "RF":
        return Item.getVideoSize("F");
      case "LV":
      case "RV":
        return Item.getVideoSize("V");
      case "LH":
      case "RH":
        return Item.getVideoSize("H");
      case "LP":
      case "RP":
        return Item.getVideoSize("P");
      default:
        return Item.getVideoSize("S");
    }
  }

  static getInitialResizerPreset(resizerMode: string) {
    switch (resizerMode) {
      case "H_S":
      case "S_F":
      case "F_S":
      case "P_F":
      case "V_F":
        return { name: "color", simpleTitle: "Color", title: "Color" };
      default:
        return { name: "color", simpleTitle: "Color", title: "Color" };
    }
  }

  recalcOuterVideoResolutionsResizer() {
    if (this.parentItem.isOutsize && this.currentSize.title === "Original") {
      this.previewParameters.outerVideoResolutionX = this.parentItem.innerVideoResolutionX;
      this.previewParameters.outerVideoResolutionY = this.parentItem.innerVideoResolutionY;
      return;
    }
    let outerVideoResolutionX = this.currentSize.defaultWidth;
    let outerVideoResolutionY = this.currentSize.defaultHeight;
    //Домножаем на пропорцию
    /* let defaultWidth = this.inputSize.defaultWidth;
    let defaultHeight = this.inputSize.defaultHeight;

    this.currentOutputParameter.previewParameters.outerVideoResolutionX = outerVideoResolutionX * this.innerVideoResolutionX / defaultWidth;
    this.currentOutputParameter.previewParameters.outerVideoResolutionY = outerVideoResolutionY * this.innerVideoResolutionY / defaultHeight; */

    let defaultWidth = this.parentItem.inputSize.defaultWidth;
    let defaultHeight = this.parentItem.inputSize.defaultHeight;
    let p = defaultWidth
      ? this.parentItem.innerVideoResolutionX / defaultWidth
      : this.parentItem.innerVideoResolutionY / defaultHeight;

    this.previewParameters.outerVideoResolutionX = outerVideoResolutionX * p;
    this.previewParameters.outerVideoResolutionY = outerVideoResolutionY * p;
  }

  getCustomShiftPadding() {
    let verticalPadding, horizontalPadding;
    let inX = this.parentItem.innerVideoResolutionX;
    let inY = this.parentItem.innerVideoResolutionY;
    let outX = this.previewParameters.outerVideoResolutionX;
    let outY = this.previewParameters.outerVideoResolutionY;
    let isHeight = inX / inY < outX / outY;
    if (isHeight) {
      let k = outY / inY;
      verticalPadding = 0;
      horizontalPadding = (outX - inX * k) / 2;
    } else {
      let k = outX / inX;
      verticalPadding = (outY - inY * k) / 2;
      horizontalPadding = 0;
    }
    return {
      verticalPadding: verticalPadding,
      horizontalPadding: horizontalPadding,
    };
  }

  getMaxShiftsResizer() {
    let maxVerticalShift, maxHorizontalShift, width, height;
    let isWidthZoom = false;
    let resizerMode =
      this.parentItem.inputSize.name + "_" + this.currentSize.name;
    let inX = this.parentItem.innerVideoResolutionX;
    let inY = this.parentItem.innerVideoResolutionY;
    let zoom = this.previewParameters.zoom / 100;
    let k = 1;
    let sizeR = Math.round((inX / inY) * 100) / 100;
    let defaultR = this.parentItem.inputSize.defaultR;
    let kL = this.parentItem.isOutsize
      ? sizeR < defaultR
        ? sizeR / defaultR
        : 1
      : 1;
    let kR = this.parentItem.isOutsize
      ? sizeR > defaultR
        ? sizeR / defaultR
        : 1
      : 1;
    switch (resizerMode) {
      //F
      case "F_S":
      case "LF_S":
      case "RF_S":
        k = 1;
        maxVerticalShift = zoom * inY - inY * (4 / 5) * k * kL * kR;
        maxHorizontalShift = zoom * inX - inX;
        isWidthZoom = true;
        break;
      case "F_H":
      case "LF_H":
      case "RF_H":
        k = 16 / 9;
        maxVerticalShift = zoom * inY * k - inY * defaultR * kL * kR;
        maxHorizontalShift = (zoom * inX - inX) * k;
        isWidthZoom = true;
        break;
      case "F_V":
      case "LF_V":
      case "RF_V":
        k = 9 / 16;
        maxVerticalShift = (zoom * inY - inY) * (4 / 5 / k);
        maxHorizontalShift = zoom * inX * (4 / 5 / k) * kL * kR - inX;
        break;
      case "F_P":
      case "LF_P":
      case "RF_P":
        k = 2 / 3;
        maxVerticalShift = (zoom * inY - inY) * (4 / 5 / k);
        maxHorizontalShift = zoom * inX * (4 / 5 / k) * kL * kR - inX;
        break;
      //S
      case "S_F":
      case "LS_F":
      case "RS_F":
        k = 4 / 5;
        maxVerticalShift = (zoom * inY - inY) / k;
        maxHorizontalShift = ((zoom * inX) / k) * kL - inX / kR;
        break;
      case "S_V":
      case "LS_V":
      case "RS_V":
        k = 9 / 16;
        maxVerticalShift = (zoom * inY - inY) / k;
        maxHorizontalShift = ((zoom * inX) / k) * kL - inX / kR;
        break;
      case "S_H":
      case "LS_H":
      case "RS_H":
        k = 16 / 9;
        maxVerticalShift = (zoom * inY * k) / kR - inY * kL;
        maxHorizontalShift = (zoom * inX - inX) * k;
        isWidthZoom = true;
        break;
      case "S_P":
      case "LS_P":
      case "RS_P":
        k = 2 / 3;
        maxVerticalShift = (zoom * inY - inY) / k;
        maxHorizontalShift = ((zoom * inX) / k) * kL - inX / kR;
        break;
      //H
      case "H_F":
      case "LH_F":
      case "RH_F":
        k = 4 / 5;
        maxVerticalShift = (zoom * inY - inY) / k;
        maxHorizontalShift = (zoom * inX) / k - inX / defaultR / kL / kR;
        break;
      case "H_V":
      case "LH_V":
      case "RH_V":
        k = 9 / 16;
        maxVerticalShift = (zoom * inY - inY) / k;
        maxHorizontalShift = (zoom * inX) / k - inX / defaultR / kL / kR;
        break;
      case "H_S":
      case "LH_S":
      case "RH_S":
        k = 1;
        maxVerticalShift = zoom * inY - inY;
        maxHorizontalShift = zoom * inX - ((inX / kL) * k * (9 / 16)) / kR;
        break;
      case "H_P":
      case "LH_P":
      case "RH_P":
        k = 2 / 3;
        maxVerticalShift = (zoom * inY - inY) / k;
        maxHorizontalShift = (zoom * inX) / k - inX / defaultR / kL / kR;
        break;
      //V
      case "V_S":
      case "LV_S":
      case "RV_S":
        k = 1;
        maxVerticalShift = zoom * inY - inY * (9 / 16) * k * kL * kR;
        maxHorizontalShift = zoom * inX - inX;
        isWidthZoom = true;
        break;
      case "V_F":
      case "LV_F":
      case "RV_F":
        k = 4 / 5;
        maxVerticalShift = zoom * inY - inY * (9 / 16 / k) * kL * kR;
        maxHorizontalShift = zoom * inX - inX;
        isWidthZoom = true;
        break;
      case "V_H":
      case "LV_H":
      case "RV_H":
        k = 16 / 9;
        maxVerticalShift = zoom * inY * k - inY * defaultR * kL * kR;
        maxHorizontalShift = (zoom * inX - inX) * k;
        isWidthZoom = true;
        break;
      case "V_P":
      case "LV_P":
      case "RV_P":
        k = 2 / 3;
        maxVerticalShift = zoom * inY - inY * (9 / 16 / k) * kL * kR;
        maxHorizontalShift = zoom * inX - inX;
        isWidthZoom = true;
        break;
      //P
      case "P_S":
      case "LP_S":
      case "RP_S":
        k = 1;
        maxVerticalShift = (zoom * inY) / kR - inY * (2 / 3) * k * kL;
        maxHorizontalShift = zoom * inX - inX;
        isWidthZoom = true;
        break;
      case "P_F":
      case "LP_F":
      case "RP_F":
        k = 4 / 5;
        maxVerticalShift = (zoom * inY) / kR - inY * (2 / 3 / k) * kL;
        maxHorizontalShift = zoom * inX - inX;
        isWidthZoom = true;
        break;
      case "P_H":
      case "LP_H":
      case "RP_H":
        k = 16 / 9;
        maxVerticalShift = (zoom * inY * k) / kR - inY * defaultR * kL;
        maxHorizontalShift = (zoom * inX - inX) * k;
        isWidthZoom = true;
        break;
      case "P_V":
      case "LP_V":
      case "RP_V":
        k = 9 / 16;
        maxVerticalShift = (zoom * inY - inY) * (2 / 3 / k);
        maxHorizontalShift = zoom * inX * (2 / 3 / k) * kL - inX / kR;
        break;

      //outsizes
      case "LS_S":
        k = 1;
        maxVerticalShift = zoom * inY - inX;
        maxHorizontalShift = zoom * inX - inX;
        isWidthZoom = true;
        break;
      case "RS_S":
        k = 1;
        maxVerticalShift = zoom * inY - inY;
        maxHorizontalShift = zoom * inX - inY;
        break;
      case "LF_F":
        k = 4 / 5;
        maxVerticalShift = zoom * inY - inX / k;
        maxHorizontalShift = zoom * inX - inX;
        isWidthZoom = true;
        break;
      case "RF_F":
        k = 4 / 5;
        maxVerticalShift = zoom * inY - inY;
        maxHorizontalShift = zoom * inX - inY * k;
        break;
      case "LV_V":
        k = 9 / 16;
        maxVerticalShift = zoom * inY - inX / k;
        maxHorizontalShift = zoom * inX - inX;
        isWidthZoom = true;
        break;
      case "RV_V":
        k = 9 / 16;
        maxVerticalShift = zoom * inY - inY;
        maxHorizontalShift = zoom * inX - inY * k;
        break;
      case "LH_H":
        k = 16 / 9;
        maxVerticalShift = zoom * inY - inX / k;
        maxHorizontalShift = zoom * inX - inX;
        isWidthZoom = true;
        break;
      case "RH_H":
        k = 16 / 9;
        maxVerticalShift = zoom * inY - inY;
        maxHorizontalShift = zoom * inX - inY * k;
        break;
      case "LP_P":
        k = 2 / 3;
        maxVerticalShift = zoom * inY - inX / k;
        maxHorizontalShift = zoom * inX - inX;
        isWidthZoom = true;
        break;
      case "RP_P":
        k = 2 / 3;
        maxVerticalShift = zoom * inY - inY;
        maxHorizontalShift = zoom * inX - inY * k;
        break;
    }

    width = isWidthZoom ? zoom * 100 : (1 / k / inY) * inX * zoom * 100;
    height = isWidthZoom ? (k / inX) * inY * zoom * 100 : zoom * 100;
    return {
      maxVerticalShift: maxVerticalShift,
      maxHorizontalShift: maxHorizontalShift,
      width: width,
      height: height,
    };
  }

  getBackgroungImageWH() {
    if (
      this.currentSize.name === this.parentItem.inputSize.name ||
      this.preset.name !== "image"
    ) {
      return null;
    }

    let outerVideoW = this.previewParameters.outerVideoResolutionX;
    let outerVideoH = this.previewParameters.outerVideoResolutionY;
    /* 		let r = outerVideoW / outerVideoH;

        let imageW = this.backgroundImage.w;
        let imageH = this.backgroundImage.h;
        let k = imageW / imageH;

        let outerImageW = 0;
        let outerImageH = 0;
        let imageType = '';
        if (k > r) {
          outerImageW = imageW * (outerVideoH / imageH);
          outerImageH = outerVideoH;
          imageType = 'height';
        } else {
          outerImageW = outerVideoW;
          outerImageH = imageH * (outerVideoW / imageW);
          imageType = 'width';
        }

        return {
          imageW: outerImageW,
          imageH: outerImageH,
          imageType: imageType
        } */

    return {
      imageW: outerVideoW,
      imageH: outerVideoH,
    };
  }

  //Slicer

  recalcOuterVideoResolutionsSlicer() {
    let size = this.currentSize.name;
    let kX = size === "H" ? 1 : 9 / 16;
    let kY =
      size === "S" || size === "H"
        ? 9 / 16
        : size === "F"
        ? 45 / 64
        : size === "P"
        ? 27 / 32
        : 1;
    this.previewParameters.outerVideoResolutionX =
      this.parentItem.innerVideoResolutionX * kX;
    this.previewParameters.outerVideoResolutionY =
      this.parentItem.innerVideoResolutionY * kY;
  }

  getMaxShiftsSlicer() {
    let maxVerticalShift, maxHorizontalShift, width, height;
    let inX = this.parentItem.innerVideoResolutionX;
    let inY = this.parentItem.innerVideoResolutionY;
    let zoom = this.previewParameters.zoom / 100;
    switch (this.currentSize.name) {
      case "S":
        maxVerticalShift = zoom * inY - (inY * 9) / 16;
        maxHorizontalShift = zoom * inX - (inX * 9) / 16;

        height = (zoom * 100 * 16) / 9;
        width = (zoom * 100 * 16) / 9;
        break;
      case "F":
        maxVerticalShift = zoom * inY - inY * (9 / 16) * (5 / 4);
        maxHorizontalShift = zoom * inX - (inX * 9) / 16;

        height = zoom * 100 * (16 / 9) * (4 / 5);
        width = (zoom * 100 * 16) / 9;
        break;
      case "P":
        maxVerticalShift = zoom * inY - inY * (9 / 16) * (3 / 2);
        maxHorizontalShift = zoom * inX - (inX * 9) / 16;

        height = zoom * 100 * (16 / 9) * (2 / 3);
        width = (zoom * 100 * 16) / 9;
        break;
      case "V":
        maxVerticalShift = zoom * inY - inY;
        maxHorizontalShift = zoom * inX - (inX * 9) / 16;

        height = zoom * 100;
        width = (zoom * 100 * 16) / 9;
        break;
      case "H":
        maxVerticalShift = zoom * inY - (inY * 9) / 16;
        maxHorizontalShift = zoom * inX - inX;

        height = (zoom * 100 * 16) / 9;
        width = zoom * 100;
        break;
    }

    return {
      maxVerticalShift: maxVerticalShift,
      maxHorizontalShift: maxHorizontalShift,
      width: width,
      height: height,
    };
  }

  checkAndUpdateMusicTime() {
    if (!this.music.file) {
      return;
    }
    if (this.music.isCustomTime) {
      if (
        this.music.startTime === undefined ||
        this.music.startTime < this.cut.startTime
      ) {
        this.music.startTime = this.cut.startTime;
      } else if (this.music.startTime > this.cut.finishTime) {
        this.music.startTime = this.cut.finishTime;
      }
    } else {
      this.music.startTime = this.cut.startTime;
    }
  }

  checkAndUpdateMoveableOverlayObjectTime(object) {
    let times = this.getMoveableOverlayObjectTimeBasedOnCurrentDuration(object);
    object.startTime = times.startTime;
    object.finishTime = times.finishTime;
  }

  getMoveableOverlayObjectTimeBasedOnCurrentDuration(object) {
    let startTime = object.startTime;
    let finishTime = object.finishTime;

    if (startTime > this.cut.finishTime || finishTime < this.cut.startTime) {
      return {
        startTime: -1,
        finishTime: -1,
      };
    }

    if (startTime < this.cut.startTime) {
      startTime = this.cut.startTime;
    }

    if (finishTime > this.cut.finishTime) {
      finishTime = this.cut.finishTime;
    }
    return {
      startTime: startTime,
      finishTime: finishTime,
    };
  }

  migrateOldFilterToNew(oldFilter) {
    let newFilter = {
      currentPreset: "Original",
      presetIntensety: 100,
      adjustment: {
        brightness: 1,
        contrast: 1,
        saturation: 1,
        tint: 0,
        invert: 0,
        sepia: 0,
        glitch: null,
        sharpen: 0,
      },
    };
    switch (oldFilter.title) {
      case "Original":
        //newFilter.currentPreset = "Original";
        break;
      case "Black & White":
        newFilter.currentPreset = "Black & White";
        newFilter.adjustment = {
          brightness: 1,
          contrast: 2,
          saturation: 0,
          tint: 0,
          invert: 0,
          sepia: 0,
          glitch: null,
          sharpen: 0,
        };
        break;
      case "Brightness":
        newFilter.currentPreset = "Brightness";
        newFilter.adjustment = {
          brightness: 1.3,
          contrast: 1,
          saturation: 1,
          tint: 0,
          invert: 0,
          sepia: 0,
          glitch: null,
          sharpen: 0,
        };
        break;
      case "Saturation":
        newFilter.currentPreset = "Saturation";
        newFilter.adjustment = {
          brightness: 1,
          contrast: 1,
          saturation: 2,
          tint: 0,
          invert: 0,
          sepia: 0,
          glitch: null,
          sharpen: 0,
        };
        break;
      case "Invert":
        newFilter.currentPreset = "Invert";
        newFilter.adjustment = {
          brightness: 1,
          contrast: 1,
          saturation: 1,
          tint: 0,
          invert: 1,
          sepia: 0,
          glitch: null,
          sharpen: 0,
        };
        break;
      case "Contrast":
        newFilter.currentPreset = "Contrast";
        newFilter.adjustment = {
          brightness: 1.1,
          contrast: 1.5,
          saturation: 1,
          tint: 0,
          invert: 0,
          sepia: 0,
          glitch: null,
          sharpen: 0,
        };
        break;
      case "Sepia":
        newFilter.currentPreset = "Sepia";
        newFilter.adjustment = {
          brightness: 1,
          contrast: 1,
          saturation: 1,
          tint: 0,
          invert: 0,
          sepia: 1,
          glitch: null,
          sharpen: 0,
        };
        break;
      case "Glitch":
        newFilter.currentPreset = "Glitch";
        newFilter.adjustment = {
          brightness: 1,
          contrast: 1,
          saturation: 1,
          tint: 0,
          invert: 0,
          sepia: 0,
          glitch: 1.7,
          sharpen: 0,
        };
        break;
      default:
        break;
    }
    return newFilter;
  }

  getFullFilter() {
    if (
      this.filter.currentPreset === "Custom" ||
      this.filter.currentPreset === "Invert"
    ) {
      return this.filter.adjustment;
    } else {
      const brightness =
        this.filter.adjustment.brightness !== 1
          ? 1 +
            ((this.filter.adjustment.brightness - 1) *
              this.filter.presetIntensety) /
              100
          : 1;
      const contrast =
        this.filter.adjustment.contrast !== 1
          ? 1 +
            ((this.filter.adjustment.contrast - 1) *
              this.filter.presetIntensety) /
              100
          : 1;
      const saturation =
        this.filter.adjustment.saturation !== 1
          ? this.filter.adjustment.saturation > 1
            ? 1 +
              ((this.filter.adjustment.saturation - 1) *
                this.filter.presetIntensety) /
                100
            : 1 - this.filter.presetIntensety / 100
          : 1;
      const sepia =
        this.filter.adjustment.sepia !== 0
          ? (this.filter.adjustment.sepia * this.filter.presetIntensety) / 100
          : 0;
      const glitch =
        this.filter.adjustment.glitch !== null
          ? (this.filter.adjustment.glitch * this.filter.presetIntensety) / 100
          : null;
      const sharpen = this.filter.adjustment.sharpen;
      return {
        brightness: brightness,
        contrast: contrast,
        saturation: saturation,
        tint: 0,
        invert: 0,
        sepia: sepia,
        glitch: glitch,
        sharpen: sharpen,
      };
    }
  }

  getFullFilterAsString() {
    let actualFilter = this.getFullFilter();
    return {
      filter:
        "brightness(" +
        actualFilter.brightness +
        ") contrast(" +
        actualFilter.contrast +
        ") saturate(" +
        actualFilter.saturation +
        ") hue-rotate(" +
        actualFilter.tint +
        "deg)" +
        " invert(" +
        actualFilter.invert +
        ")" +
        " sepia(" +
        actualFilter.sepia +
        ")",
      glitch: actualFilter.glitch,
      sharpen: actualFilter.sharpen,
    };
  }

  getFileOutputSizeMb() {
    let cutVideoDuration = this.cut.finishTime - this.cut.startTime;
    let endCardDuration = this.endCard.getDuration(
      this.currentSize.name.toLowerCase()
    );

    let videosDuration = cutVideoDuration / this.speed + endCardDuration;
    let audiosDuration = videosDuration;
    let bitrate = this.fileOutputParameters.bitrate;

    let videoSize = (videosDuration * bitrate * 0.125) / 1000;
    let audioSize = audiosDuration * 0.0175;
    return Math.round((videoSize + audioSize) * 100) / 100;
  }

  recalcFileOutputParameters() {
    if (!this.parentItem.fileId) {
      return;
    }
    let w = Math.round(
      this.previewParameters.outerVideoResolutionX *
        this.previewParameters.userOuterVideoResolutionsDifference
    );
    let h = Math.round(
      this.previewParameters.outerVideoResolutionY *
        this.previewParameters.userOuterVideoResolutionsDifference
    );
    let bitrate = w * h * this.parentItem.fps * 0.00011;
    if (
      this.parentItem.bitrate &&
      this.parentItem.bitrate > 0 &&
      this.parentItem.bitrate > bitrate
    ) {
      //let calculatedBitrate = this.parentItem.innerVideoResolutionX * this.parentItem.innerVideoResolutionY * this.parentItem.fps * 0.00011;
      //let k = this.parentItem.bitrate / calculatedBitrate;
      //bitrate *= k;
      bitrate = this.parentItem.bitrate;
    }

    let cutVideoDuration = this.cut.finishTime - this.cut.startTime;
    let endCardDuration = this.endCard.packshot
      ? this.endCard.packshot.list[this.currentSize.name.toLowerCase()].duration
      : 0;

    let videosDuration = cutVideoDuration * this.speed + endCardDuration;
    let audiosDuration = videosDuration;

    let videoSize = (videosDuration * bitrate * 0.125) / 1000;
    let audioSize = audiosDuration * 0.0175;

    this.fileOutputParameters.bitrate = Math.round(bitrate);
    this.fileOutputParameters.normalBitrate = Math.round(bitrate);
  }
}
